import { render, staticRenderFns } from "./PdfReminderList.vue?vue&type=template&id=3e034789&scoped=true"
import script from "./PdfReminderList.vue?vue&type=script&lang=js"
export * from "./PdfReminderList.vue?vue&type=script&lang=js"
import style0 from "./PdfReminderList.vue?vue&type=style&index=0&id=3e034789&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e034789",
  null
  
)

export default component.exports